// extracted by mini-css-extract-plugin
export var buttonRoot = "Button-module--buttonRoot--H1+v0";
export var loadingRoot = "Button-module--loadingRoot--1KRHt";
export var disabledRoot = "Button-module--disabledRoot--mqtWY";
export var fluffyRoot = "Button-module--fluffyRoot--xswrR";